// extracted by mini-css-extract-plugin
module.exports = {"like":"like_like__1rJ5e"};